import { loginWidget } from "../widgets/login/loginWidget.js";

let fdLoginContainer = document.getElementById('fdLoginContainer');
let opts = {};

let fdLoginWidget = new loginWidget(fdLoginContainer, opts);